import { ACCOUNT_TYPES } from './common.js';

export const FEATURED_POSTS = [
  {
    name: 'juls',
    url: 'https://juicyhouse-profile-images.s3.us-east-1.wasabisys.com/image/569738dd-b46f-4635-b72a-6c158cef825f.jpeg',
    content: 'Creators keep 100% of their earnings for tips, calls, subscriptions and ppv content 💰',
    time: '2m'
  },
  {
    name: 'Mark',
    url: 'https://juicyhouse-profile-images.s3.us-east-1.wasabisys.com/image/92ce781b-8f69-4f93-8a8c-97d7828f32bb.jpeg',  
    content: 'Be seen by the right people with our advanced discovery algorithm 🌎',
    time: '5m'
  }
];

// Account option data
export const ACCOUNT_OPTIONS = [
  {
    type: ACCOUNT_TYPES.CREATOR,
    title: 'Content Creator',
    subtitle: 'Share your content and build an audience',
    icon: 'fas fa-heart',
    buttonText: 'Become a Housemate',
    features: [
      'Free & premium content on one profile',
      'Monetize your work - keep 100%',
      'Get discovered and grow your audience'
    ]
  },
  {
    type: ACCOUNT_TYPES.SUBSCRIBER,
    title: 'Subscriber',
    subtitle: 'Discover and enjoy exclusive content',
    icon: 'fas fa-user',
    buttonText: 'Join as a Subscriber',
    features: [
      'Access premium content',
      'Personalized recommendations',
      'Talk to your favorite creators'
    ]
  }
];


export const UNDER_REVIEW_VERIFICATION_STEPS = [
  { id: 'account-created', text: 'Account Created', status: 'completed' },
  { id: 'document-verification', text: 'Document Verification', status: 'in-progress' },
  { id: 'final-approval', text: 'Final Approval', status: 'pending' }
];

export const UNDER_REVIEW_INFO_ITEMS = [
  'Our team reviews your documents',
  'You\'ll receive an email notification',
  'Login with your credentials once approved'
];

 // Static trending profiles data
 export const TRENDING_PROFILES_LISTS = [
  {
    id: 1,
    username: '@trending_star',
    avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-9.jpg',
    status: 'Trending Content',
    isFollowing: false
  },
  {
    id: 2,
    username: '@viral_creator',
    avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg',
    status: 'Trending Profile',
    price: '$9.99/mo',
    isFollowing: false
  },
  {
    id: 3,
    username: '@hot_content',
    avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-4.jpg',
    status: 'Trending Content',
    isFollowing: false
  },
  {
    id: 4,
    username: '@music_master',
    avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-3.jpg',
    status: 'Trending Profile',
    price: '$6.99/mo',
    isFollowing: false
  },
  {
    id: 5,
    username: '@art_goddess',
    avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-5.jpg',
    status: 'Trending Content',
    isFollowing: false
  },
  {
    id: 6,
    username: '@fitness_queen',
    avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-6.jpg',
    status: 'Trending Profile',
    price: '$11.99/mo',
    isFollowing: false
  },
  {
    id: 7,
    username: '@tech_guru',
    avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-7.jpg',
    status: 'Trending Content',
    isFollowing: false
  },
  {
    id: 8,
    username: '@gaming_pro',
    avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-8.jpg',
    status: 'Trending Profile',
    price: '$8.99/mo',
    isFollowing: false
  },
  {
    id: 9,
    username: '@food_lover',
    avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-2.jpg',
    status: 'Trending Content',
    isFollowing: false
  },
  {
    id: 10,
    username: '@style_icon',
    avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg',
    status: 'Trending Profile',
    price: '$14.99/mo',
    isFollowing: false
  }
];

export const DEFAULT_SOCIAL_LINKS = [
  {
      href: 'https://x.com/joinjuicyhouse?s=21',
      iconClass: 'fa-brands fa-x-twitter',
      label: 'Join Juicy House on X'
  },
  {
      href: 'https://www.instagram.com/joinjuicyhouse?igsh=bzE4MGk2eWZmNzg2',
      iconClass: 'fa-brands fa-instagram',
      label: 'Follow Juicy House on Instagram'
  },
  {
      href: 'https://www.tiktok.com/@joinjuicyhouse?_r=1&_t=ZP-93LRqRd3sS6',
      iconClass: 'fa-brands fa-tiktok',
      label: 'Follow Juicy House on TikTok'
  }
];

export const REPORT_REASONS = [
  "Violence or dangerous organizations",
  "Sexual behavior towards underage kids (17 and younger)",
  "Sexual assault or forceful actions",
  "Bestiality",
  "Drug abuse or illegal activities",
  "Mutilation",
  "Other"
];
